import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  ipLogsData: null,
  loadingIpLogs: false,
  error: null,
};

const ipLogsSlice = createSlice({
  name: "ipLogs",
  initialState,
  reducers: {
    setIpLogsData: (state, action) => {
      state.ipLogsData = action.payload;
      state.error = null;
    },
    setLoadingIpLogs: (state, action) => {
      state.loadingIpLogs = action.payload;
    },
    setIpLogsError: (state, action) => {
      state.error = action.payload;
      state.loadingIpLogs = false;
    },
    clearIpLogsData: (state) => {
      state.ipLogsData = null;
      state.error = null;
      state.loadingIpLogs = false;
    },
  },
});

export const { 
  setIpLogsData, 
  setLoadingIpLogs, 
  setIpLogsError, 
  clearIpLogsData 
} = ipLogsSlice.actions;

export default ipLogsSlice.reducer;
